// extracted by mini-css-extract-plugin
export var o_banner2 = "banner2-module--o_banner2--158e6";
export var o_banner2__bg = "banner2-module--o_banner2__bg--2becd";
export var o_banner2__body = "banner2-module--o_banner2__body--09384";
export var o_banner2__extra = "banner2-module--o_banner2__extra--5991b";
export var o_banner2__h2 = "banner2-module--o_banner2__h2--6a292";
export var o_banner2__info = "banner2-module--o_banner2__info--ab424";
export var o_banner2__link = "banner2-module--o_banner2__link--37954";
export var rotation = "banner2-module--rotation--04cdf";